module.exports = __webpack_public_path__ + "static/media/send-message-in-private.2127c2a2.svg";